import axios from '../../utils/axios-wrapper';

const getEncodedBody = (body) => {
  let formBody = [];
  for (const property in body) {
    const encodedKey = encodeURIComponent(property);

    let encodedValue;
    if (property === 'pdf') {
      encodedValue = encodeURIComponent(body[property]);
    } else {
      encodedValue = body[property];
    }

    encodedValue =
      typeof encodedValue === 'object'
        ? JSON.stringify(encodedValue)
        : encodedValue;
    formBody.push(`${encodedKey}=${encodedValue}`);
  }
  formBody = formBody.join('&');
  return formBody;
};

export default {
  addTaxExemption(addTaxExemptionUrl, pdfPayload) {
    return axios.post(addTaxExemptionUrl, getEncodedBody(pdfPayload), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },

  getPDF(pdfUrl) {
    return axios.get(pdfUrl, {
      responseType: 'blob',
      headers: {},
    });
  },
};
